export function priceAlertMessage(name, message, fallback = '') {
  const text = (typeof message === 'string' ? message.trim() : '') || fallback
  return text ? `${name} - ${text}` : name
}

// The symbol belongs to the alert, not to the editable name. Accept older
// full-name values without duplicating the ticker when rendering them.
export function alertNameSuffix(symbol, value = '') {
  const text = typeof value === 'string' ? value.trim() : ''
  if (!symbol || !text.toUpperCase().startsWith(symbol.toUpperCase())) return text
  const tail = text.slice(symbol.length)
  return !tail || /^[\s·:—–-]/.test(tail) ? tail.replace(/^[\s·:—–-]+/, '') : text
}
export function priceAlertName(symbol, value = '') {
  const suffix = alertNameSuffix(symbol, value)
  return symbol ? suffix ? `${symbol} · ${suffix}` : symbol : suffix
}
